import T from 'prop-types';
import React from 'react';

import { be, bm } from '@skippay/core/utils/classUtils';

import { ReactComponent as MenuText } from './img/icon-menu-text.svg';

import './index.sass';

const MODULE_NAME = 'HamburgerMenu';

const renderHamburgerMenu = (props) => {
	const { onClick: handleOnClick, inverted, isOpen } = props;

	return (
		<button
			aria-label="Menu"
			className={bm(MODULE_NAME, { inverted, isOpen })}
			onClick={handleOnClick}
			type="button"
		>
			<div className={be(MODULE_NAME, 'hamburger')}>
				<span className={be(MODULE_NAME, 'hamburgerRow')} />
				<span className={be(MODULE_NAME, 'hamburgerRow')} />
				<span className={be(MODULE_NAME, 'hamburgerRow')} />
				<span className={be(MODULE_NAME, 'hamburgerRow')} />
			</div>
			<div className={be(MODULE_NAME, 'text')}>
				<MenuText />
			</div>
		</button>
	);
};

const HamburgerMenu = renderHamburgerMenu;

HamburgerMenu.propTypes = {
	inverted: T.bool,
	isOpen: T.bool,
	onClick: T.func.isRequired,
};

HamburgerMenu.defaultProps = {
	inverted: false,
};

export default HamburgerMenu;
